export const environment =
{
	production: false,
	ambient: "Claro",
	language: "ES",
	clientId: "535f8681-6338-4a6f-ac5c-f9c9e672a301",
	baseUrlAccess: "https://v4ky7utf2gzo.kravata.co/api/v1",
	baseUrlClient: "https://v4ky7utf2gzo.kravata.co/api/v1",
	baseUrlCustodian: "https://v4ky7utf2gzo.kravata.co/api/v1",
	baseUrlBusiness: "https://v4ky7utf2gzo.kravata.co/api/v1",
	baseUrlTransaction: "https://v4ky7utf2gzo.kravata.co/api/v1",
	baseMFEUrl: "https://frwidget-claro-test.kravata.co",
	baseCoreUrl: "https://frwidget-demo-test.kravata.co",
	urlFiles: "https://test-admin.internal.kravata.co/api/utils/loadfiles",
	apiUrlFiles: "https://testapi.kravata.co/api",
	brebRechargeKey: "901595603"
};